import { useState, useEffect } from 'react'
import { db, auth, functions } from '../../firebase'
import { doc, getDocs, collection, getDoc, collectionGroup, where, query } from 'firebase/firestore'
import UserInfoModule from './Modes.module.scss'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthState } from 'react-firebase-hooks/auth'
import { ColorRing } from 'react-loader-spinner'
import ModeSearch from '../ModeSearch/ModeSearch'
import ai from '../../assets/ai.png'
import { httpsCallable } from 'firebase/functions'
import LoadingGrid from '../LoadingGrid/LoadingGrid'
import { isWithinTimeWindow } from '../../utils/timeWindowUtils'
import { useGetTranslatedValue } from '../../lang/lang'

function Modes({ serviceType }) {
  const translate = useGetTranslatedValue()
  const [user] = useAuthState(auth)
  const navigate = useNavigate()
  const [modes, setModes] = useState([])
  const [filteredModes, setFilteredModes] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchText, setSearchText] = useState('')
  const [isGettingParentSchoolModes, setIsGettingParentSchoolModes] = useState(false)

  const getSchoolData = async (paramSchoolId) => {
    try {
      if (paramSchoolId) {
        // console.log('paramSchoolId', paramSchoolId)

        const getSchoolInfoOfMingaku = httpsCallable(functions, 'get_school_info_of_mingaku')
        const schoolDataOfMingaku = await getSchoolInfoOfMingaku({ schoolId: paramSchoolId })
        const { configData } = schoolDataOfMingaku.data
        // console.log('configData', configData)
        const { parentSchools = [] } = configData
        return { parentSchools }
      }
    } catch (error) {
      console.error('Error fetching document IDs:', error)
    }
  }

  const getStudentData = async (userinfo) => {
    try {
      if (!!userinfo.data().studentDocId) {
        // 生徒
        const getStudentInfo = httpsCallable(functions, 'get_student_info_of_mingaku')
        const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
        const [studentInfo, schoolInfo] = await Promise.all([
          getStudentInfo({ nandeUserId: userinfo.data().userId }),
          getSchoolsInfo({ schoolIds: [userinfo.data().schoolDocId] })
        ])
        const schoolId = schoolInfo.data.schoolInfo[0].data.id
        const studentId = studentInfo.data.data.id
        // Find the matching classroom object by classroomId

        // 検索の仕方によっては空の場合'-'に変更したほうが良いかもしれない
        // console.log({
        //   name: studentInfo.data.data.name,
        //   loginId: `${schoolId}-${studentId}`, //みんがくスクールID
        //   schoolName: schoolInfo.data.schoolInfo[0].data.name || '-',
        //   id: userinfo.id, //firebase user ID,
        //   schoolId: schoolId,
        //   classRoomId: studentInfo.data.data.classroomId || '-',
        //   schoolAiSchoolId: userinfo.data().schoolDocId
        // })
        return {
          name: studentInfo.data.data.name,
          loginId: `${schoolId}-${studentId}`, //みんがくスクールID
          schoolName: schoolInfo.data.schoolInfo[0].data.name || '-',
          id: userinfo.id, //firebase user ID,
          schoolId: schoolId,
          classRoomId: studentInfo.data.data.classroomId || '-',
          schoolAiSchoolId: userinfo.data().schoolDocId
        }
      }
    } catch (error) {
      console.error('Error fetching user data from Mingaku:', error)
      return null // エラー時には null を返す
    }
  }
  const fetchModes = async () => {
    if (user) {
      setLoading(true)
      const userDocRef = doc(db, 'users', user.uid)
      const userDocSnapshot = await getDoc(userDocRef)
      const userData = userDocSnapshot.data()
      const { type, schoolDocId, studentDocId, role } = userData

      if (userDocSnapshot.exists()) {
        let finalUsableModes = []
        const adminFilnalUsableModes = []

        const gptPromptDocRef = doc(db, 'service_type', 'gpt-teacher')
        const adminPromptsCollectionRef = collection(gptPromptDocRef, 'prompts')

        try {
          // アドミンのモード
          // const adminPromptsSnapshot = await getDocs(query(adminPromptsCollectionRef, where('enable', '==', true)))

          const q = query(adminPromptsCollectionRef, where('enable', '==', true))

          const adminPromptsSnapshot = await getDocs(q)

          // ドキュメントデータをadminFilnalUsableModesに格納
          adminFilnalUsableModes.push(...adminPromptsSnapshot.docs.map((doc) => doc.data()))

          if (schoolDocId) {
            const adminPromptsWithoutSelectedSchoolsPromises = await Promise.all(
              adminPromptsSnapshot.docs.map(async (doc) => {
                if (doc.data().availableAllSchools === false) {
                  const selectedSchoolsRef = collection(doc.ref, 'selectedSchools')
                  const selectedSchoolSnapshot = await getDocs(
                    query(selectedSchoolsRef, where('id', '==', schoolDocId))
                  )
                  if (selectedSchoolSnapshot.docs.length > 0) {
                    const selectedSchoolDoc = selectedSchoolSnapshot.docs[0]
                    if (selectedSchoolDoc.data().active !== true) {
                      return null
                    } else {
                      return {
                        ...doc.data(),
                        id: doc.id,
                        editable: false,
                        active: true
                        // parentSchoolId: parentSchool.schoolDocId
                      }
                    }
                  }
                } else {
                  const selectedSchoolsRef = collection(doc.ref, 'selectedSchools')
                  const selectedSchoolSnapshot = await getDocs(
                    query(selectedSchoolsRef, where('id', '==', schoolDocId))
                  )
                  if (selectedSchoolSnapshot.docs.length > 0) {
                    const selectedSchoolDoc = selectedSchoolSnapshot.docs[0]
                    if (selectedSchoolDoc.data().active !== true) {
                      return null
                    } else {
                      return {
                        ...doc.data(),
                        id: doc.id,
                        editable: false,
                        active: true
                        // parentSchoolId: parentSchool.schoolDocId
                      }
                    }
                  } else {
                    return {
                      ...doc.data(),
                      id: doc.id,
                      editable: false,
                      active: true
                      // parentSchoolId: parentSchool.schoolDocId
                    }
                  }
                }
              })
            ).then((results) => results.filter((result) => result != null))
            // console.log(adminPromptsWithoutSelectedSchoolsPromises)
            finalUsableModes.push(...adminPromptsWithoutSelectedSchoolsPromises)
            setModes(finalUsableModes)
          } else {
            setModes(adminFilnalUsableModes)
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        }

        try {
          if (type === 'mingaku' && schoolDocId) {
            const mingakuUserData = await getStudentData(userDocSnapshot)

            // ------------------ 自分の学校のモード確認 ---------------------
            const mySchoolPromptsCollectionRef = collection(
              db,
              `/externalServices/mingaku/schools/${schoolDocId}/prompts`
            )
            // const mySchoolPromptsCollectionRef = collection(mySchoolPromptDocRef, 'prompts')
            const querySnapshot = await getDocs(query(mySchoolPromptsCollectionRef, where('enable', '==', true)))

            // クラスルーム & 生徒チェック
            // console.log('③parentFilteredModes', querySnapshot)
            const finalParentSchoolModes = []
            if (role === 'tutor') {
              for (const modeDoc of querySnapshot.docs) {
                finalUsableModes.push(modeDoc.data())
              } // チェックを通過した場合に追加
            } else {
              const { classRoomId } = mingakuUserData
              for (const modeDoc of querySnapshot.docs) {
                const mode = modeDoc.data()
                // クラスルームチェック
                if (mode.availableAllClassRooms === false) {
                  const selectedClassRoomsRef = collection(mode.ref, 'selectedClassRooms')
                  const selectedClassRoomsSnapshot = await getDocs(
                    query(selectedClassRoomsRef, where('id', '==', classRoomId))
                  )
                  if (selectedClassRoomsSnapshot.docs.length === 0) {
                    // console.log('クラスルームNG', mode.prompt_title)
                    continue // クラスルームに属していない場合はスキップ
                  } else if (mode.availableAllStudents === false) {
                    const selectedStudentsRef = collection(mode.ref, 'selectedStudents')
                    const selectedStudentsSnapshot = await getDocs(
                      query(selectedStudentsRef, where('id', '==', userData.userId))
                    )
                    if (selectedStudentsSnapshot.docs.length === 0) {
                      // console.log('生徒NG', mode.prompt_title)
                      continue // 生徒に含まれていない場合はスキップ
                    }
                  }
                } else if (mode.availableAllStudents === false) {
                  // 生徒チェック
                  const selectedStudentsRef = collection(mode.ref, 'selectedStudents')
                  const selectedStudentsSnapshot = await getDocs(
                    query(selectedStudentsRef, where('id', '==', userData.userId))
                  )
                  if (selectedStudentsSnapshot.docs.length === 0) {
                    // console.log('生徒NG', mode.prompt_title)
                    continue // 生徒に含まれていない場合はスキップ
                  }
                }

                // すべての条件を通過した場合にのみ、finalUsableModesに追加
                finalUsableModes.push(mode)
              }
            }

            // ------------- 親スクールのモード確認 ------------------
            setIsGettingParentSchoolModes(true)
            // console.log('スクールID', schoolDocId)
            const { parentSchools = [] } = await getSchoolData(schoolDocId)
            // 親スクールがいた場合、親スクールの共有モードを確認
            if (parentSchools && parentSchools.length > 0) {
              const parentSchool = parentSchools[0] // 必ず1つの学校がある前提
              // 学校チェック
              const parentPromptsCollectionRef = collection(
                db,
                `/externalServices/mingaku/schools/${parentSchool.schoolDocId}/prompts`
              )
              // const parentPromptDocRef = doc(schoolsCollectionRef, parentSchool.schoolDocId)
              // const parentPromptsCollectionRef = collection(parentPromptDocRef, 'prompts')
              const querySnapshot = await getDocs(query(parentPromptsCollectionRef, where('enable', '==', true)))

              const parentFilteredModes = await Promise.all(
                querySnapshot.docs.map(async (doc) => {
                  if (doc.data().availableAllSchools === false) {
                    const selectedSchoolsRef = collection(doc.ref, 'selectedSchools')
                    const selectedSchoolSnapshot = await getDocs(
                      query(selectedSchoolsRef, where('id', '==', schoolDocId))
                    )
                    if (selectedSchoolSnapshot.docs.length > 0) {
                      const selectedSchoolDoc = selectedSchoolSnapshot.docs[0]
                      if (selectedSchoolDoc.data().active !== true) {
                        return null
                      } else {
                        return {
                          ...doc.data(),
                          id: doc.id,
                          editable: false,
                          active: true,
                          parentSchoolId: parentSchool.schoolDocId
                        }
                      }
                    }
                  } else {
                    const selectedSchoolsRef = collection(doc.ref, 'selectedSchools')
                    const selectedSchoolSnapshot = await getDocs(
                      query(selectedSchoolsRef, where('id', '==', schoolDocId))
                    )
                    if (selectedSchoolSnapshot.docs.length > 0) {
                      const selectedSchoolDoc = selectedSchoolSnapshot.docs[0]
                      if (selectedSchoolDoc.data().active !== true) {
                        return null
                      } else {
                        return {
                          ...doc.data(),
                          id: doc.id,
                          editable: false,
                          active: true,
                          parentSchoolId: parentSchool.schoolDocId
                        }
                      }
                    } else {
                      return {
                        ...doc.data(),
                        id: doc.id,
                        editable: false,
                        active: true,
                        parentSchoolId: parentSchool.schoolDocId
                      }
                    }
                  }
                })
              ).then((results) => results.filter((result) => result != null))

              // クラスルーム & 生徒チェック
              // console.log('③parentFilteredModes', parentFilteredModes)
              const finalParentSchoolModes = []
              if (role === 'tutor') {
                for (const mode of parentFilteredModes) {
                  // クラスルームチェック
                  finalUsableModes.push(mode) // チェックを通過した場合に追加
                }
              } else {
                const { classRoomId } = mingakuUserData
                // console.log('④parentFilteredModes', parentFilteredModes)
                for (const mode of parentFilteredModes) {
                  // クラスルームチェック
                  // console.log('⑤mode', mode)

                  if (mode.availableAllClassRooms === false) {
                    const selectedClassRoomsRef = collection(mode.ref, 'selectedClassRooms')
                    const selectedClassRoomsSnapshot = await getDocs(
                      query(selectedClassRoomsRef, where('id', '==', classRoomId))
                    )
                    if (selectedClassRoomsSnapshot.docs.length === 0) {
                      // console.log('クラスルームNG', mode.prompt_title)
                      continue // クラスルームに属していない場合はスキップ
                    } else if (mode.availableAllStudents === false) {
                      const selectedStudentsRef = collection(mode.ref, 'selectedStudents')
                      const selectedStudentsSnapshot = await getDocs(
                        query(selectedStudentsRef, where('id', '==', userData.userId))
                      )
                      if (selectedStudentsSnapshot.docs.length === 0) {
                        // console.log('生徒NG', mode.prompt_title)
                        continue // 生徒に含まれていない場合はスキップ
                      }
                    }
                  } else if (mode.availableAllStudents === false) {
                    // 生徒チェック
                    const selectedStudentsRef = collection(mode.ref, 'selectedStudents')
                    const selectedStudentsSnapshot = await getDocs(
                      query(selectedStudentsRef, where('id', '==', userData.userId))
                    )
                    if (selectedStudentsSnapshot.docs.length === 0) {
                      // console.log('生徒NG', mode.prompt_title)
                      continue // 生徒に含まれていない場合はスキップ
                    }
                  }
                  finalUsableModes.push(mode) // チェックを通過した場合に追加
                }
              }
            }

            // console.log('OKモード', finalUsableModes)
            finalUsableModes = await Promise.all(
              finalUsableModes.map(async (mode) => {
                if (mode.enable !== false && (await isWithinTimeWindow(null, mode.ref))) {
                  return mode
                }
                return null
              })
            )
            setModes(finalUsableModes.filter((mode) => mode != null))

            setIsGettingParentSchoolModes(false)
          }
          setLoading(false)
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      }
    }
  }

  useEffect(() => {
    fetchModes()
  }, [user, serviceType])

  useEffect(() => {
    if (modes.length > 0) {
      // console.log('フィルター', modes)
      const filtered = modes.filter((mode) => mode.prompt_title.toLowerCase().includes(searchText.toLowerCase()))
      setFilteredModes(filtered)
    }
  }, [searchText, modes])

  const selectMode = async (mode) => {
    navigate(
      `/redirect?mode=${mode.ref.id}&common=${mode.common ? mode.common.toString() : 'false'}&showheader=true&ref=${
        mode.ref.path
      }`,
      {
        state: { common: mode.common ? mode.common : false }
      }
    )
  }

  return (
    <>
      {loading ? (
        <LoadingGrid />
      ) : (
        <div className={UserInfoModule['modeContainer']}>
          {modes.length === 0 ? (
            <div className={UserInfoModule['no-modes-message']}>まだモードがないようです...</div>
          ) : (
            <>
              <ModeSearch
                placeholderMessage={`${translate('searchModes')}...`}
                searchText={searchText}
                setSearchText={setSearchText}
              />
              <div className={UserInfoModule['modes']}>
                {filteredModes
                  .sort((a, b) => a.prompt_order - b.prompt_order)
                  .map((mode, index) => (
                    <div className={UserInfoModule.mode} key={index}>
                      <div
                        className={UserInfoModule.title}
                        style={mode.modeColor ? { background: `${mode.modeColor}` } : {}}
                      >
                        <div className={UserInfoModule['rounded-icon']}>
                          <img src={mode.iconImageUrl ? mode.iconImageUrl : ai}></img>
                        </div>
                        <h4 className={UserInfoModule.title}>{mode.prompt_title}</h4>
                      </div>
                      <div className={UserInfoModule.cardBottomContainer}>
                        {mode.prompt_description && mode.prompt_description !== '' ? (
                          <div className={UserInfoModule.description}>{mode.prompt_description}</div>
                        ) : (
                          <div className={UserInfoModule.description}>{''}</div>
                        )}
                        <div onClick={() => selectMode(mode)} className={UserInfoModule.start}>
                          {translate('start')}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              {isGettingParentSchoolModes && (
                <div className={UserInfoModule['loading-container']}>
                  <ColorRing
                    visible={true}
                    height="50"
                    width="50"
                    ariaLabel="color-ring-loading"
                    wrapperStyle={{}}
                    wrapperClass="color-ring-wrapper"
                    colors={['#5bc6e1', '#60caf4', '#6aa3f8', '#81b2bd', '#849b96']}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  )
}

export default Modes
